import { Data } from "../../Models/Common/Common";
import { Post } from "../../Utils/AxiosHelper/AxiosHelper";

const api = {
  getUnits: "configurations/getShowrooms",
  getAvailableCities: "configurations/getAvailableCities",
};
const UnitServices = {
  GetUnits: (command: any, then: Data<any>) => {
    Post(api.getUnits, command, then);
  },
  GetAvailableCities: (command: any, then: Data<any>) => {
    Post(api.getAvailableCities, command, then);
  },
};
export default UnitServices;
